import {post} from './httpBase';
//常用乘车人列表
export function passengerList(params) {
    return post('/user/common/list', params)
}
//添加常用乘车人
export function addPassenger(params) {
    return post('/user/common/addcommon', params)
}
//删除常用乘车人
export function deletePassenger(params) {
    return post('/user/common/delete', params)
}


// WEBPACK FOOTER //
// ./src/service/passengerService.js